import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'
import { useApiFormAsset, useApiListAsset } from '../../../../../../api-new/state/content'
import { Menu, MenuLink, MenuPurge, MenuRestore } from '../../../../../../shared/menu/menu'
import { IconAdd, IconList, IconRecycle } from '../../../../../../shared/icon/icon'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { Purge } from '../../../../../../shared/page/page-purge'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnDateTime, ColumnMenu, ColumnText } from '../../../../../../shared/table-builder/table-columns'
import { recycleErrorMessage } from '../../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../../shared/error/use-error-line'

export const AssetListRecycle = ({ nodeID }) => {
  const { url } = useRouteMatch()

  const apiListAsset = useApiListAsset()

  const [error, failure, setError] = useErrorLine()

  const handleReady = async () => apiListAsset.get(`${nodeID}/deleted-parent`)
  const handleDestroyed = () => apiListAsset.init()

  const handleRestore = async id => {
    setError(null)
    try {
      await apiListAsset.put(`${id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That asset was already removed.'), err)
    }
    await apiListAsset.get(`${nodeID}/deleted-parent`)
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuLink Icon={IconAdd} text="new asset" to={`${url}/add`} show={true} />
      <MenuLink Icon={IconRecycle} text="recycle" to={`${url}/recycle`} show={true} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="recycle">
        <CardFullHeightScrollY title="recycle" HeaderMenu={HeaderMenu}>
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListAsset} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnDateTime field="createdAt" />
            <ColumnDateTime field="updatedAt" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row.id)} show />
                  <MenuPurge to={`${url}/purge/${row.id}`} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/purge/:purgeID`}>
        <Purge useApiForm={useApiFormAsset} titleParam="name" successPath={url} />
      </Route>
    </React.Fragment>
  )
}
